// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import CollapseArrow from '../_raw/ui/icon_collapse_arrow.svg';
import withIconProps from '../withIconProps';

export default withIconProps(CollapseArrow);
